// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__39dZ-","container":"styles_container__1_GZ8","title":"styles_title__-P_x3","wrapper":"styles_wrapper__18WGU","answer":"styles_answer__TJ2ik"};